/**
 * Extracts the items array from a /options-shaped response.
 * Accepts either a bare array or `{ data: [...] }`. Returns `[]` for any
 * other shape (null, undefined, primitive, object without array `data`).
 *
 * Used by `createApiOptionsLoader` and `createApiOptionsLookup`.
 *
 * @param {unknown} response
 * @returns {unknown[]}
 */
export function extractApiItems(response) {
  if (response == null || typeof response !== 'object') return [];
  if (Array.isArray(response)) return response;
  const data = /** @type {Record<string, unknown>} */ (response).data;
  if (Array.isArray(data)) return data;
  return [];
}
